import React from "react";
import "./App.css";
import "./styles/bootstrap.css";
import "./styles/style.css";
import { LoadingProvider } from "./shared/services/providers/loading.context";
import CustomMain from "./main/main";

function App() {
  return (
    <React.Fragment>
      <LoadingProvider>
        <CustomMain />
      </LoadingProvider>
    </React.Fragment>
  );
}

export default App;
